// Abrir una pantalla del ERP desde cualquier parte (p. ej. la cartola completa del cliente desde el
// panel de la nota o del punto de venta). La provee el Shell; fuera de él no hace nada.
import { createContext, useContext } from 'react';

export type Navegar = (ruta: string, params?: Record<string, string>) => void;

export const NavegarContexto = createContext<Navegar | null>(null);

export const useNavegar = (): Navegar | null => useContext(NavegarContexto);
